import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
  CardFooter,
} from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { ArrowRight, Calendar, MapPin, User } from 'lucide-react'
import { blogPosts } from '@/data/blogPosts'
import { Link } from 'react-router-dom'

export const BlogSection = () => {
  // Get the last 3 posts for the preview
  const previewPosts = blogPosts.slice(0, 3)

  return (
    <section id="blog" className="py-20 bg-white">
      <div className="container px-4 md:px-6 mx-auto">
        <div className="text-center mb-16">
          <Badge
            variant="outline"
            className="mb-4 px-4 py-1 border-super-green text-super-green font-bold"
          >
            Blog SuperFut
          </Badge>
          <h2 className="text-3xl md:text-4xl font-display font-bold text-super-text mb-4">
            Dicas e Novidades
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Conteúdos exclusivos sobre desenvolvimento infantil, esporte e
            educação para pais e mães em São Paulo.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {previewPosts.map((post) => (
            <Card
              key={post.slug}
              className="border-slate-100 shadow-sm hover:shadow-lg transition-all duration-300 group overflow-hidden flex flex-col h-full"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4">
                  <Badge className="bg-white/90 text-super-blue hover:bg-white shadow-sm backdrop-blur-sm">
                    {post.category}
                  </Badge>
                </div>
              </div>
              <CardHeader className="pb-2">
                <div className="flex items-center gap-4 text-xs text-slate-500 mb-2">
                  <div className="flex items-center gap-1">
                    <Calendar className="w-3 h-3" />
                    {post.date}
                  </div>
                  <div className="flex items-center gap-1">
                    <MapPin className="w-3 h-3" />
                    {post.location}
                  </div>
                </div>
                <Link to={`/blog/${post.slug}`}>
                  <CardTitle className="text-xl font-bold text-slate-800 leading-tight group-hover:text-super-blue transition-colors line-clamp-2">
                    {post.title}
                  </CardTitle>
                </Link>
              </CardHeader>
              <CardContent className="flex-grow">
                <CardDescription className="text-slate-600 line-clamp-3">
                  {post.excerpt}
                </CardDescription>
              </CardContent>
              <CardFooter className="pt-0 border-t border-slate-50 mt-4 pt-4">
                <div className="flex justify-between items-center w-full">
                  <div className="flex items-center gap-2">
                    <div className="w-6 h-6 rounded-full bg-slate-100 flex items-center justify-center">
                      <User className="w-3 h-3 text-slate-500" />
                    </div>
                    <span className="text-xs font-medium text-slate-600">
                      {post.author}
                    </span>
                  </div>
                  <Button
                    variant="ghost"
                    size="sm"
                    className="text-super-blue hover:text-super-green p-0 h-auto font-bold group/btn"
                    asChild
                  >
                    <Link to={`/blog/${post.slug}`}>
                      Ler mais{' '}
                      <ArrowRight className="w-3 h-3 ml-1 transition-transform group-hover/btn:translate-x-1" />
                    </Link>
                  </Button>
                </div>
              </CardFooter>
            </Card>
          ))}
        </div>

        <div className="mt-12 text-center">
          <Button
            variant="outline"
            className="border-super-blue text-super-blue hover:bg-super-blue hover:text-white rounded-full px-8"
            asChild
          >
            <Link to="/blog">Ver todos os artigos</Link>
          </Button>
        </div>
      </div>
    </section>
  )
}
